import type { DateTimeEntryConfig} from './CSVDateTimeSelector.js';

export const SamplingDateConfig: DateTimeEntryConfig = {
  label: "Sampling Date",
  type: "samplingDate",
  helpText: "Select the column containing sampling date/time information",
  setter: (p, value) => { p.samplingDate = value },
}

export const SamplingStartConfig: DateTimeEntryConfig = {
  label: "Sampling Start Date",
  type: "samplingStart",
  helpText: "Select the column containing info about when sampling started",
  setter: (p, value) => { p.samplingStart = value },
}

export const SamplingEndConfig: DateTimeEntryConfig = {
  label: "Sampling End Date",
  type: "samplingEnd",
  helpText: "Select the column containing info about when sampling ended",
  setter: (p, value) => { p.samplingEnd = value },
}